<template>
  <div id="app">
    <div id="navbar">
      <div class="layout-navbar">
        <div class="logoheader">
          <img class="logo" src="./assets/logo.png" />
          <router-link to="/scanner"
            ><svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              viewBox="0 0 24 24"
            >
              <path
                d="M16.1666667,6 C16.0746192,6 16,6.07461921 16,6.16666667 L16,7.83333333 C16,7.92538079 16.0746192,8 16.1666667,8 L17.8333333,8 C17.9253808,8 18,7.92538079 18,7.83333333 L18,6.16666667 C18,6.07461921 17.9253808,6 17.8333333,6 L16.1666667,6 Z M16,18 L16,17.5 C16,17.2238576 16.2238576,17 16.5,17 C16.7761424,17 17,17.2238576 17,17.5 L17,18 L18,18 L18,17.5 C18,17.2238576 18.2238576,17 18.5,17 C18.7761424,17 19,17.2238576 19,17.5 L19,18.5 C19,18.7761424 18.7761424,19 18.5,19 L14.5,19 C14.2238576,19 14,18.7761424 14,18.5 L14,17.5 C14,17.2238576 14.2238576,17 14.5,17 C14.7761424,17 15,17.2238576 15,17.5 L15,18 L16,18 L16,18 Z M13,11 L13.5,11 C13.7761424,11 14,11.2238576 14,11.5 C14,11.7761424 13.7761424,12 13.5,12 L11.5,12 C11.2238576,12 11,11.7761424 11,11.5 C11,11.2238576 11.2238576,11 11.5,11 L12,11 L12,10 L10.5,10 C10.2238576,10 10,9.77614237 10,9.5 C10,9.22385763 10.2238576,9 10.5,9 L13.5,9 C13.7761424,9 14,9.22385763 14,9.5 C14,9.77614237 13.7761424,10 13.5,10 L13,10 L13,11 Z M18,12 L17.5,12 C17.2238576,12 17,11.7761424 17,11.5 C17,11.2238576 17.2238576,11 17.5,11 L18,11 L18,10.5 C18,10.2238576 18.2238576,10 18.5,10 C18.7761424,10 19,10.2238576 19,10.5 L19,12.5 C19,12.7761424 18.7761424,13 18.5,13 C18.2238576,13 18,12.7761424 18,12.5 L18,12 Z M13,14 L12.5,14 C12.2238576,14 12,13.7761424 12,13.5 C12,13.2238576 12.2238576,13 12.5,13 L13.5,13 C13.7761424,13 14,13.2238576 14,13.5 L14,15.5 C14,15.7761424 13.7761424,16 13.5,16 L10.5,16 C10.2238576,16 10,15.7761424 10,15.5 C10,15.2238576 10.2238576,15 10.5,15 L13,15 L13,14 L13,14 Z M16.1666667,5 L17.8333333,5 C18.4776655,5 19,5.52233446 19,6.16666667 L19,7.83333333 C19,8.47766554 18.4776655,9 17.8333333,9 L16.1666667,9 C15.5223345,9 15,8.47766554 15,7.83333333 L15,6.16666667 C15,5.52233446 15.5223345,5 16.1666667,5 Z M6.16666667,5 L7.83333333,5 C8.47766554,5 9,5.52233446 9,6.16666667 L9,7.83333333 C9,8.47766554 8.47766554,9 7.83333333,9 L6.16666667,9 C5.52233446,9 5,8.47766554 5,7.83333333 L5,6.16666667 C5,5.52233446 5.52233446,5 6.16666667,5 Z M6.16666667,6 C6.07461921,6 6,6.07461921 6,6.16666667 L6,7.83333333 C6,7.92538079 6.07461921,8 6.16666667,8 L7.83333333,8 C7.92538079,8 8,7.92538079 8,7.83333333 L8,6.16666667 C8,6.07461921 7.92538079,6 7.83333333,6 L6.16666667,6 Z M6.16666667,15 L7.83333333,15 C8.47766554,15 9,15.5223345 9,16.1666667 L9,17.8333333 C9,18.4776655 8.47766554,19 7.83333333,19 L6.16666667,19 C5.52233446,19 5,18.4776655 5,17.8333333 L5,16.1666667 C5,15.5223345 5.52233446,15 6.16666667,15 Z M6.16666667,16 C6.07461921,16 6,16.0746192 6,16.1666667 L6,17.8333333 C6,17.9253808 6.07461921,18 6.16666667,18 L7.83333333,18 C7.92538079,18 8,17.9253808 8,17.8333333 L8,16.1666667 C8,16.0746192 7.92538079,16 7.83333333,16 L6.16666667,16 Z M13,6 L10.5,6 C10.2238576,6 10,5.77614237 10,5.5 C10,5.22385763 10.2238576,5 10.5,5 L13.5,5 C13.7761424,5 14,5.22385763 14,5.5 L14,7.5 C14,7.77614237 13.7761424,8 13.5,8 C13.2238576,8 13,7.77614237 13,7.5 L13,6 Z M10.5,8 C10.2238576,8 10,7.77614237 10,7.5 C10,7.22385763 10.2238576,7 10.5,7 L11.5,7 C11.7761424,7 12,7.22385763 12,7.5 C12,7.77614237 11.7761424,8 11.5,8 L10.5,8 Z M5.5,14 C5.22385763,14 5,13.7761424 5,13.5 C5,13.2238576 5.22385763,13 5.5,13 L7.5,13 C7.77614237,13 8,13.2238576 8,13.5 C8,13.7761424 7.77614237,14 7.5,14 L5.5,14 Z M9.5,14 C9.22385763,14 9,13.7761424 9,13.5 C9,13.2238576 9.22385763,13 9.5,13 L10.5,13 C10.7761424,13 11,13.2238576 11,13.5 C11,13.7761424 10.7761424,14 10.5,14 L9.5,14 Z M11,18 L11,18.5 C11,18.7761424 10.7761424,19 10.5,19 C10.2238576,19 10,18.7761424 10,18.5 L10,17.5 C10,17.2238576 10.2238576,17 10.5,17 L12.5,17 C12.7761424,17 13,17.2238576 13,17.5 C13,17.7761424 12.7761424,18 12.5,18 L11,18 Z M9,11 L9.5,11 C9.77614237,11 10,11.2238576 10,11.5 C10,11.7761424 9.77614237,12 9.5,12 L8.5,12 C8.22385763,12 8,11.7761424 8,11.5 L8,11 L7.5,11 C7.22385763,11 7,10.7761424 7,10.5 C7,10.2238576 7.22385763,10 7.5,10 L8.5,10 C8.77614237,10 9,10.2238576 9,10.5 L9,11 Z M5,10.5 C5,10.2238576 5.22385763,10 5.5,10 C5.77614237,10 6,10.2238576 6,10.5 L6,11.5 C6,11.7761424 5.77614237,12 5.5,12 C5.22385763,12 5,11.7761424 5,11.5 L5,10.5 Z M15,10.5 C15,10.2238576 15.2238576,10 15.5,10 C15.7761424,10 16,10.2238576 16,10.5 L16,12.5 C16,12.7761424 15.7761424,13 15.5,13 C15.2238576,13 15,12.7761424 15,12.5 L15,10.5 Z M17,15 L17,14.5 C17,14.2238576 17.2238576,14 17.5,14 L18.5,14 C18.7761424,14 19,14.2238576 19,14.5 C19,14.7761424 18.7761424,15 18.5,15 L18,15 L18,15.5 C18,15.7761424 17.7761424,16 17.5,16 L15.5,16 C15.2238576,16 15,15.7761424 15,15.5 L15,14.5 C15,14.2238576 15.2238576,14 15.5,14 C15.7761424,14 16,14.2238576 16,14.5 L16,15 L17,15 Z M3,6.5 C3,6.77614237 2.77614237,7 2.5,7 C2.22385763,7 2,6.77614237 2,6.5 L2,4.5 C2,3.11928813 3.11928813,2 4.5,2 L6.5,2 C6.77614237,2 7,2.22385763 7,2.5 C7,2.77614237 6.77614237,3 6.5,3 L4.5,3 C3.67157288,3 3,3.67157288 3,4.5 L3,6.5 Z M17.5,3 C17.2238576,3 17,2.77614237 17,2.5 C17,2.22385763 17.2238576,2 17.5,2 L19.5,2 C20.8807119,2 22,3.11928813 22,4.5 L22,6.5 C22,6.77614237 21.7761424,7 21.5,7 C21.2238576,7 21,6.77614237 21,6.5 L21,4.5 C21,3.67157288 20.3284271,3 19.5,3 L17.5,3 Z M6.5,21 C6.77614237,21 7,21.2238576 7,21.5 C7,21.7761424 6.77614237,22 6.5,22 L4.5,22 C3.11928813,22 2,20.8807119 2,19.5 L2,17.5 C2,17.2238576 2.22385763,17 2.5,17 C2.77614237,17 3,17.2238576 3,17.5 L3,19.5 C3,20.3284271 3.67157288,21 4.5,21 L6.5,21 Z M21,17.5 C21,17.2238576 21.2238576,17 21.5,17 C21.7761424,17 22,17.2238576 22,17.5 L22,19.5 C22,20.8807119 20.8807119,22 19.5,22 L17.5,22 C17.2238576,22 17,21.7761424 17,21.5 C17,21.2238576 17.2238576,21 17.5,21 L19.5,21 C20.3284271,21 21,20.3284271 21,19.5 L21,17.5 Z"
              /></svg
          ></router-link>
          <div class="viewLink">
            <router-link to="/">{{ $t("Home") }}</router-link>
            <router-link to="/subscriber">{{ $t("Subscriber") }}</router-link>
            <router-link to="/runner">{{ $t("A.D") }}</router-link>
            <router-link to="/dealer">{{ $t("Dealer") }}</router-link>
          </div>
        </div>
        <div class="navbar-links">
          <router-link to="/update">{{ $t("NFT Status") }}</router-link>
          <router-link to="/record">{{ $t("PreMint Record") }}</router-link>
          <router-link to="/edit">{{ $t("Category/Type") }}</router-link>
          <div class="dropdown-title">
            <router-link to="/validation">{{ $t("Validation") }}</router-link>
            <div class="dropDownList">
              <router-link to="/mintstatus">{{
                $t("Mint Status")
              }}</router-link>
            </div>
          </div>
          <router-link to="/nftstatus">{{ $t("Return Request") }}</router-link>
          <button class="connect" @click="connect">
            {{ userAddress ? userAddress : $t("Connect Wallet") }}
          </button>
        </div>
        <button class="mobile-connect" @click="connect">
          {{ userAddress ? userAddress : $t("Connect") }}
        </button>
        <div class="menu">
          <b-button class="menu-btn" v-b-toggle.sidebar-backdrop>
            <b-icon-list></b-icon-list>
          </b-button>
        </div>
      </div>

      <b-sidebar
        id="sidebar-backdrop"
        :backdrop-variant="variant"
        right
        backdrop
        shadow
      >
        <div class="sidebar-content">
          <!-- <b-form-group label="Backdrop variant" label-for="backdrop-variant">
            <b-form-select id="backdrop-variant" v-model="variant" :options="variants"></b-form-select>
          </b-form-group> -->
          <!-- <img class="logo" src="./assets/logo.png"> -->
          <!-- <router-link to="/scanner"
            ><svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <path
                d="M16.1666667,6 C16.0746192,6 16,6.07461921 16,6.16666667 L16,7.83333333 C16,7.92538079 16.0746192,8 16.1666667,8 L17.8333333,8 C17.9253808,8 18,7.92538079 18,7.83333333 L18,6.16666667 C18,6.07461921 17.9253808,6 17.8333333,6 L16.1666667,6 Z M16,18 L16,17.5 C16,17.2238576 16.2238576,17 16.5,17 C16.7761424,17 17,17.2238576 17,17.5 L17,18 L18,18 L18,17.5 C18,17.2238576 18.2238576,17 18.5,17 C18.7761424,17 19,17.2238576 19,17.5 L19,18.5 C19,18.7761424 18.7761424,19 18.5,19 L14.5,19 C14.2238576,19 14,18.7761424 14,18.5 L14,17.5 C14,17.2238576 14.2238576,17 14.5,17 C14.7761424,17 15,17.2238576 15,17.5 L15,18 L16,18 L16,18 Z M13,11 L13.5,11 C13.7761424,11 14,11.2238576 14,11.5 C14,11.7761424 13.7761424,12 13.5,12 L11.5,12 C11.2238576,12 11,11.7761424 11,11.5 C11,11.2238576 11.2238576,11 11.5,11 L12,11 L12,10 L10.5,10 C10.2238576,10 10,9.77614237 10,9.5 C10,9.22385763 10.2238576,9 10.5,9 L13.5,9 C13.7761424,9 14,9.22385763 14,9.5 C14,9.77614237 13.7761424,10 13.5,10 L13,10 L13,11 Z M18,12 L17.5,12 C17.2238576,12 17,11.7761424 17,11.5 C17,11.2238576 17.2238576,11 17.5,11 L18,11 L18,10.5 C18,10.2238576 18.2238576,10 18.5,10 C18.7761424,10 19,10.2238576 19,10.5 L19,12.5 C19,12.7761424 18.7761424,13 18.5,13 C18.2238576,13 18,12.7761424 18,12.5 L18,12 Z M13,14 L12.5,14 C12.2238576,14 12,13.7761424 12,13.5 C12,13.2238576 12.2238576,13 12.5,13 L13.5,13 C13.7761424,13 14,13.2238576 14,13.5 L14,15.5 C14,15.7761424 13.7761424,16 13.5,16 L10.5,16 C10.2238576,16 10,15.7761424 10,15.5 C10,15.2238576 10.2238576,15 10.5,15 L13,15 L13,14 L13,14 Z M16.1666667,5 L17.8333333,5 C18.4776655,5 19,5.52233446 19,6.16666667 L19,7.83333333 C19,8.47766554 18.4776655,9 17.8333333,9 L16.1666667,9 C15.5223345,9 15,8.47766554 15,7.83333333 L15,6.16666667 C15,5.52233446 15.5223345,5 16.1666667,5 Z M6.16666667,5 L7.83333333,5 C8.47766554,5 9,5.52233446 9,6.16666667 L9,7.83333333 C9,8.47766554 8.47766554,9 7.83333333,9 L6.16666667,9 C5.52233446,9 5,8.47766554 5,7.83333333 L5,6.16666667 C5,5.52233446 5.52233446,5 6.16666667,5 Z M6.16666667,6 C6.07461921,6 6,6.07461921 6,6.16666667 L6,7.83333333 C6,7.92538079 6.07461921,8 6.16666667,8 L7.83333333,8 C7.92538079,8 8,7.92538079 8,7.83333333 L8,6.16666667 C8,6.07461921 7.92538079,6 7.83333333,6 L6.16666667,6 Z M6.16666667,15 L7.83333333,15 C8.47766554,15 9,15.5223345 9,16.1666667 L9,17.8333333 C9,18.4776655 8.47766554,19 7.83333333,19 L6.16666667,19 C5.52233446,19 5,18.4776655 5,17.8333333 L5,16.1666667 C5,15.5223345 5.52233446,15 6.16666667,15 Z M6.16666667,16 C6.07461921,16 6,16.0746192 6,16.1666667 L6,17.8333333 C6,17.9253808 6.07461921,18 6.16666667,18 L7.83333333,18 C7.92538079,18 8,17.9253808 8,17.8333333 L8,16.1666667 C8,16.0746192 7.92538079,16 7.83333333,16 L6.16666667,16 Z M13,6 L10.5,6 C10.2238576,6 10,5.77614237 10,5.5 C10,5.22385763 10.2238576,5 10.5,5 L13.5,5 C13.7761424,5 14,5.22385763 14,5.5 L14,7.5 C14,7.77614237 13.7761424,8 13.5,8 C13.2238576,8 13,7.77614237 13,7.5 L13,6 Z M10.5,8 C10.2238576,8 10,7.77614237 10,7.5 C10,7.22385763 10.2238576,7 10.5,7 L11.5,7 C11.7761424,7 12,7.22385763 12,7.5 C12,7.77614237 11.7761424,8 11.5,8 L10.5,8 Z M5.5,14 C5.22385763,14 5,13.7761424 5,13.5 C5,13.2238576 5.22385763,13 5.5,13 L7.5,13 C7.77614237,13 8,13.2238576 8,13.5 C8,13.7761424 7.77614237,14 7.5,14 L5.5,14 Z M9.5,14 C9.22385763,14 9,13.7761424 9,13.5 C9,13.2238576 9.22385763,13 9.5,13 L10.5,13 C10.7761424,13 11,13.2238576 11,13.5 C11,13.7761424 10.7761424,14 10.5,14 L9.5,14 Z M11,18 L11,18.5 C11,18.7761424 10.7761424,19 10.5,19 C10.2238576,19 10,18.7761424 10,18.5 L10,17.5 C10,17.2238576 10.2238576,17 10.5,17 L12.5,17 C12.7761424,17 13,17.2238576 13,17.5 C13,17.7761424 12.7761424,18 12.5,18 L11,18 Z M9,11 L9.5,11 C9.77614237,11 10,11.2238576 10,11.5 C10,11.7761424 9.77614237,12 9.5,12 L8.5,12 C8.22385763,12 8,11.7761424 8,11.5 L8,11 L7.5,11 C7.22385763,11 7,10.7761424 7,10.5 C7,10.2238576 7.22385763,10 7.5,10 L8.5,10 C8.77614237,10 9,10.2238576 9,10.5 L9,11 Z M5,10.5 C5,10.2238576 5.22385763,10 5.5,10 C5.77614237,10 6,10.2238576 6,10.5 L6,11.5 C6,11.7761424 5.77614237,12 5.5,12 C5.22385763,12 5,11.7761424 5,11.5 L5,10.5 Z M15,10.5 C15,10.2238576 15.2238576,10 15.5,10 C15.7761424,10 16,10.2238576 16,10.5 L16,12.5 C16,12.7761424 15.7761424,13 15.5,13 C15.2238576,13 15,12.7761424 15,12.5 L15,10.5 Z M17,15 L17,14.5 C17,14.2238576 17.2238576,14 17.5,14 L18.5,14 C18.7761424,14 19,14.2238576 19,14.5 C19,14.7761424 18.7761424,15 18.5,15 L18,15 L18,15.5 C18,15.7761424 17.7761424,16 17.5,16 L15.5,16 C15.2238576,16 15,15.7761424 15,15.5 L15,14.5 C15,14.2238576 15.2238576,14 15.5,14 C15.7761424,14 16,14.2238576 16,14.5 L16,15 L17,15 Z M3,6.5 C3,6.77614237 2.77614237,7 2.5,7 C2.22385763,7 2,6.77614237 2,6.5 L2,4.5 C2,3.11928813 3.11928813,2 4.5,2 L6.5,2 C6.77614237,2 7,2.22385763 7,2.5 C7,2.77614237 6.77614237,3 6.5,3 L4.5,3 C3.67157288,3 3,3.67157288 3,4.5 L3,6.5 Z M17.5,3 C17.2238576,3 17,2.77614237 17,2.5 C17,2.22385763 17.2238576,2 17.5,2 L19.5,2 C20.8807119,2 22,3.11928813 22,4.5 L22,6.5 C22,6.77614237 21.7761424,7 21.5,7 C21.2238576,7 21,6.77614237 21,6.5 L21,4.5 C21,3.67157288 20.3284271,3 19.5,3 L17.5,3 Z M6.5,21 C6.77614237,21 7,21.2238576 7,21.5 C7,21.7761424 6.77614237,22 6.5,22 L4.5,22 C3.11928813,22 2,20.8807119 2,19.5 L2,17.5 C2,17.2238576 2.22385763,17 2.5,17 C2.77614237,17 3,17.2238576 3,17.5 L3,19.5 C3,20.3284271 3.67157288,21 4.5,21 L6.5,21 Z M21,17.5 C21,17.2238576 21.2238576,17 21.5,17 C21.7761424,17 22,17.2238576 22,17.5 L22,19.5 C22,20.8807119 20.8807119,22 19.5,22 L17.5,22 C17.2238576,22 17,21.7761424 17,21.5 C17,21.2238576 17.2238576,21 17.5,21 L19.5,21 C20.3284271,21 21,20.3284271 21,19.5 L21,17.5 Z"
              /></svg
          ></router-link> -->
          <router-link to="/">{{ $t("Home") }}</router-link>
          <router-link to="/subscriber">{{ $t("Subscriber") }}</router-link>
          <router-link to="/runner">{{ $t("A.D") }}</router-link>
          <router-link to="/dealer">{{ $t("Dealer") }}</router-link>
          <router-link to="/edit">{{ $t("Category/Type") }}</router-link>
          <router-link to="/mintstatus">{{ $t("Mint Status") }}</router-link>
          <router-link to="/nftstatus">{{ $t("Request Return") }}</router-link>
          <router-link to="/update">{{ $t("NFT Status") }}</router-link>
          <router-link to="/validation">{{ $t("Validation") }}</router-link>
          <router-link to="/record">{{ $t("PreMint Record") }}</router-link>
        </div>
      </b-sidebar>
    </div>
    <router-view :connectStatus="connectStatus" @connect="connect" />
  </div>
</template>
<script>
  import "./assets/css/style.css";
  // import ABI from "./components/AdminContract.json";
  // const { ethers } = require("ethers");

  export default {
    name: "App",
    data() {
      return {
        walletStatus: false,
        userAddress: "",
        connectStatus: false,
      };
    },
    mounted: async function () {
      await this.connect();
      window.ethereum.on("connect", (res) => {
        console.log(res);
        window.location.reload();
      });

      window.ethereum.on("disconnect", () => {
        this.connectStatus = false;
        localStorage.removeItem("address");
        window.location.reload();
      });

      window.ethereum.on("accountsChanged", (accounts) => {
        if (accounts.length == 0) {
          this.connectStatus = false;
          localStorage.removeItem("address");
        } else {
          this.connectStatus = true;
        }
        window.location.reload();
      });
    },
    methods: {
      async connect() {
        if (window.ethereum == undefined) {
          alert("Please install metamask!");
        }
        // let user = localStorage.address;
        // if (user == undefined) {

        let checkNetwork = this.switchNetwork();
        if (!checkNetwork) {
          return false;
        }

        if (this.connectStatus == false) {
          // console.log("??");
          await window.ethereum.request({ method: "eth_requestAccounts" });
          let user = window.ethereum.selectedAddress;
          // }
          this.connectStatus = true;
          this.walletStatus = !this.walletStatus;
          this.userAddress = user.substr(0, 5) + "...." + user.substr(-4, 4);
          localStorage.address = user.toString();
        } else {
          // console.log("??????");
          let user = localStorage.address;
          this.connectStatus = true;
          this.walletStatus = !this.walletStatus;
          this.userAddress = user.substr(0, 5) + "...." + user.substr(-4, 4);
          localStorage.address = user.toString();
        }
      },
      async switchNetwork() {
        try {
          await window.ethereum.request({
            method: "wallet_switchEthereumChain",
            // params: [{ chainId: "0x61" }],
            params: [{ chainId: "0x38" }],
          });
        } catch (e) {
          if (e.code == 4902) {
            alert("Please add BSC testnet to your network.");
          }
          console.log(e.message);
          return false;
        }
        return true;
      },
    },
  };
</script>
<style>
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }

  #nav {
    padding: 30px;
  }

  #nav a {
    font-weight: bold;
    color: #2c3e50;
  }

  #navbar div a.router-link-exact-active,
  #navbar div .viewLink a.router-link-exact-active {
    color: var(--gold);
  }

  #navbar {
    background-color: rgb(17, 18, 19);
    box-shadow: rgb(0 0 0 / 80%) 0px 0px 10px;
    width: 100%;
  }

  #navbar .layout-navbar {
    display: flex;
    justify-content: space-between;
    background-image: initial;
    width: 90%;
    padding: 10px;
    align-items: center;
    margin: auto;
  }

  #navbar .b-sidebar > .b-sidebar-header {
    display: flex;
    width: 100%;
    justify-content: flex-end;
    background-color: rgb(17, 18, 19);
    height: 60px;
  }

  #navbar .b-sidebar.b-sidebar-right > .b-sidebar-header .close {
    margin-right: 0;
  }

  #navbar .b-sidebar > .b-sidebar-body {
    background-color: rgb(17, 18, 19);
  }

  .navbar-links {
    display: none;
    align-items: center;
  }

  .layout-navbar > div > a > svg,
  .sidebar-content > a > svg {
    fill: white;
  }

  .sidebar-content {
    display: flex;
    flex-direction: column;
  }

  .logoheader {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  #navbar a,
  .dropdown-title {
    color: rgba(255, 255, 255, 0.6);
    text-decoration: none;
    /* margin-right: 10px; */
    padding: 10px;
  }

  #navbar a:hover,
  .dropdown-title:hover {
    color: var(--gold);
  }

  .logo {
    width: 150px;
  }

  .menu {
    display: block;
  }

  .menu .btn-check:focus + .btn-secondary,
  .btn-secondary:focus,
  .btn-secondary {
    box-shadow: none !important;
    border-color: transparent !important;
    background-color: transparent !important;
  }

  #navbar .close {
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: none;
    color: rgba(255, 255, 255, 0.8) !important;
  }

  .footer-container {
    position: relative;
    bottom: 0;
    background-color: rgb(17, 18, 19);
    box-shadow: rgb(0 0 0 / 80%) 0px 0px 10px;
    display: none;
  }

  .footer-top-section,
  .footer-bottom-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 70%;
    margin: auto;
  }

  .footer-top-section:nth-child(1) {
    padding-top: 20px;
  }

  .footer-bottom-section .remarks {
    font-size: 0.8rem;
  }

  .footer-top-section img {
    width: 250px;
  }

  .footer-right-links ul {
    display: flex;
    list-style: none;
    justify-content: center;
    margin-top: 10px;
  }

  .footer-right-links li {
    padding: 10px;
  }

  .footer-right-links li a {
    color: var(--gold);
    text-decoration: none;
  }

  .mobile-connect,
  .connect {
    background: var(--gold-gradient);
    color: white;
    border: 1px solid transparent;
    border-radius: 12px;
    padding: 6px 10px;
  }

  .viewLink,
  .dropDownList {
    display: none;
  }

  .dropdown-title {
    position: relative;
  }

  .dropDownList {
    justify-content: center;
    flex-direction: column;
    position: absolute;
  }

  .dropDownList > a {
    border: 1px solid #2c3e50;
    background: black;
  }

  .dropdown-title:hover ~ .dropDownList,
  .dropdown-title > a:hover ~ .dropDownList,
  .dropDownList:hover {
    display: flex;
    transition: 4s ease-in-out;
    right: 0px;
  }

  @media only screen and (min-width: 768px) {
    .logo {
      width: 250px;
    }
    .viewLink {
      display: flex;
      width: 60%;
    }
    .navbar-links {
      display: flex;
    }
    .menu {
      display: none;
    }
    .footer-top-section,
    .footer-bottom-section {
      flex-direction: row;
      justify-content: space-between;
    }
    .mobile-connect {
      display: none;
    }
    .mobile-connect,
    .connect {
      background: var(--gold-gradient);
      color: white;
      border: 1px solid transparent;
      border-radius: 12px;
      padding: 10px 30px;
    }
  }
</style>
